import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import phrasesType from '../proptypes/phrases';
import profileWithArchetypeType from '../proptypes/profile-with-archetype';
import selectComparisonTableData from '../selectors/comparison-table-data';
import PageSection from './PageSection';
import SpyRoleTable from './SpyRoleTable';
import ChallengesTable from './ChallengesTable';
import AttributesTable from './AttributesTable';
import {
  Header4, BoldParagraph,
} from './Typography';
import LinkButton from './LinkButton';
import { ssColorBlack } from '../constants/style-constants';

const comparisonCTACSS = css`
  color: ${ssColorBlack};
`;

const CompareSectionHeading = styled(Header4)`
  margin-bottom: 2rem;
`;

const PlayMoreGamesCTA = ({ gamesPath, buttonTitle, copy }) => (
  <>
    <div className="row">
      <BoldParagraph className="col-md-6 col-lg-4">{copy}</BoldParagraph>
    </div>
    <LinkButton
      title={buttonTitle}
      className="btn-primary btn-block col-md-6 col-lg-4"
      css={comparisonCTACSS}
      url={gamesPath}
    />
  </>
);

PlayMoreGamesCTA.propTypes = {
  copy: PropTypes.string.isRequired,
  buttonTitle: PropTypes.string.isRequired,
  gamesPath: PropTypes.string.isRequired,
};

const ComparisonTable = ({
  currentProfile,
  comparedProfile,
  phrases,
  urls: {
    gamesPath,
    currentProfileSpyRolePath,
    specialOpsVideoPath,
  },
}) => {
  const {
    comparison: {
      spyRoleSection,
      attributesSection,
      challengesSection,
      playMoreGamesCtaCopy,
      playMoreGamesCtaButtonTitle,
    },
  } = phrases;

  const comparisonTableData = selectComparisonTableData(
    currentProfile,
    comparedProfile,
    phrases,
    currentProfileSpyRolePath,
    specialOpsVideoPath,
  );
  const { spyRoles, challenges, attributes } = comparisonTableData;

  return (
    <div data-testid="comparison-table">
      <PageSection theme="dark_navy" className="spy-role-section">
        <CompareSectionHeading>{spyRoleSection.title}</CompareSectionHeading>
        {spyRoles && <SpyRoleTable data={spyRoles} />}
        <PlayMoreGamesCTA
          gamesPath={gamesPath}
          buttonTitle={playMoreGamesCtaButtonTitle}
          copy={playMoreGamesCtaCopy}
        />
      </PageSection>
      <PageSection theme="dark_navy" className="challenges-section">
        <CompareSectionHeading>{challengesSection.title}</CompareSectionHeading>
        <ChallengesTable data={challenges} />
      </PageSection>
      <PageSection theme="dark_navy" className="attributes-section">
        <CompareSectionHeading>{attributesSection.title}</CompareSectionHeading>
        <AttributesTable data={attributes} />
        <PlayMoreGamesCTA
          gamesPath={gamesPath}
          buttonTitle={playMoreGamesCtaButtonTitle}
          copy={playMoreGamesCtaCopy}
        />
      </PageSection>
    </div>
  );
};

ComparisonTable.propTypes = {
  currentProfile: profileWithArchetypeType.isRequired,
  comparedProfile: profileWithArchetypeType.isRequired,
  phrases: phrasesType.isRequired,
  urls: PropTypes.shape({
    gamesPath: PropTypes.string.isRequired,
    currentProfileSpyRolePath: PropTypes.string.isRequired,
    specialOpsVideoPath: PropTypes.string.isRequired,
  }).isRequired,
};

export default ComparisonTable;
